import { getClientDeviceFlags } from "~/utils/helpers";

export default defineNuxtPlugin(() => {
  return {
    provide: getClientDeviceFlags(),
  };
});
